// Translation for uk
export const uk = {
        common: {
            save: 'Зберегти',
            cancel: 'Скасувати',
            close: 'Закрити',
            delete: 'Видалити',
            edit: 'Редагувати',
            activate: 'Активувати',
            add: 'Додати',
            saving: 'Збереження...',
            loading: 'Завантаження...',
            active: 'АКТИВНО',
            inUse: 'Використовується',
            test: 'Тест',
            searchApps: 'Пошук додатків...',
            betaBanner: 'BETA - Сервіс ще недоступний!'
        },
        header: {
            creditBalance: 'Баланс',
            minutes: 'ХВ'
        },
        auth: {
            signIn: 'Вхід',
            signUp: 'Реєстрація',
            username: 'Ім\'я користувача',
            password: 'Пароль',
            continue: 'Продовжити',
            noAccount: 'Немаєш облікового запису?',
            hasAccount: 'У тебе вже є обліковий запис?',
            loginError: 'Помилка входу',
            invalidCredentials: 'Невірне ім\'я користувача або пароль',
            rateLimited: 'Занадто багато спроб входу. Будь ласка, почекай.',
            sessionExpired: 'Твоя сесія закінчилася. Будь ласка, використовуй нове чарівне посилання.',
            magicLinkInvalid: 'Посилання для входу невірне або закінчилося.',
            magicLinkSuccess: 'Ласкаво просимо! Ти успішно увійшов.',
            magicLinkProcessing: 'Обробка входу...',
            connectionError: 'Помилка підключення. Будь ласка, спробуй ще раз.'
        },
        profile: {
            myProgress: 'Мій прогрес навчання',
            signOut: 'Вихід',
            plan: 'План: '
        },
        settings: {
            title: 'Параметри',
            tabs: {
                uiSettings: 'Параметри UI',
                systemPrompt: 'Системний запит',
                llmProfiles: 'Профілі LLM',
                ttsProfiles: 'Профілі TTS',
                language: 'Мова',
            },
            uiSettings: {
                title: 'Користувацький інтерфейс',
                themeMode: 'Режим теми',
                darkMode: 'Темний режим',
                lightMode: 'Світлий режим',
                themeColor: 'Колір теми',
                themeColorDesc: 'Виберіть колір акценту для кнопок, іконок і виділень',
                background: 'Фон',
                backgroundDesc: 'Виберіть фон для свого робочого простору',
                selectBackgroundColor: 'Виберіть колір фону',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Фокус',
                    concentration: 'Концентрація',
                    relaxation: 'Розслаблення',
                    lianas: 'Ліани',
                    color: 'Колір'
                },
                backgroundColors: {
                    deepDark: 'Глибокий чорний',
                    darkGrey: 'Темно-сірий',
                    midnightBlue: 'Напівніч Синій',
                    indigo: 'Індиго',
                    darkTeal: 'Темно-синій-зелений',
                    brown: 'Коричневий',
                    darkRed: 'Темно-червоний',
                    deepPurple: 'Глибокий фіолетовий',
                    pureWhite: 'Чистий білий',
                    softWhite: 'М\'який білий',
                    lightGrey: 'Світло-сірий',
                    paleBlue: 'Блідо-синій',
                    paleGreen: 'Блідо-зелений',
                    paleOrange: 'Блідо-помаранчевий',
                    lavender: 'Лаванда',
                    blueGrey: 'Синьо-сірий'
                }
            },
            systemPrompt: {
                label: 'Системний запит:',
                placeholder: 'Завантаження системного запиту...',
                emptyError: 'Системний запит не може бути порожнім!',
                saveSuccess: '✓ Системний запит успішно збережено!',
                loadError: 'Помилка при завантаженні системного запиту',
                saveError: 'Помилка при збереженні'
            },
            llmProfiles: {
                addButton: '+ Додати нове з\'єднання',
                newConnection: 'Нове з\'єднання',
                editConnection: 'Редагувати з\'єднання',
                emptyState: 'Немає доступних з\'єднань LLM. Натисніть нижче для додання.',
                loadingProfiles: 'Завантаження профілів...',
                nameLabel: 'Ім\'я *',
                namePlaceholder: 'наприклад OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Модель *',
                modelPlaceholder: 'gpt-4, mistral-tiny, і т.д.',
                allFieldsRequired: 'Усі поля мають бути заповнені!',
                saveSuccess: '✓ Профіль успішно збережено!',
                deleteConfirm: 'Ти впевнений, що хочеш видалити "{name}"?',
                profileNotFound: 'Профіль не знайдено!',
                loadError: 'Помилка при завантаженні профілів',
                saveError: 'Помилка при збереженні',
                activateError: 'Помилка при активації',
                deleteError: 'Помилка при видаленні',
                modelInfo: 'Модель: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Додати новий голос',
                newVoice: 'Новий голос',
                editVoice: 'Редагувати голос',
                emptyState: 'Немає доступних профілів TTS. Натисніть нижче для додання.',
                loadingProfiles: 'Завантаження профілів TTS...',
                nameLabel: 'Ім\'я',
                namePlaceholder: 'наприклад Мій ElevenLabs Adam',
                providerLabel: 'Постачальник',
                providerPlaceholder: 'наприклад ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API ключ *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID моделі *',
                modelIdPlaceholder: 'наприклад eleven_monolingual_v1',
                voiceIdLabel: 'ID голосу',
                voiceIdPlaceholder: 'наприклад pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Усі поля мають бути заповнені!',
                saveSuccess: '✓ Профіль TTS успішно збережено!',
                deleteConfirm: 'Ти впевнений, що хочеш видалити "{name}"?',
                loadError: 'Помилка при завантаженні профілів TTS',
                saveError: 'Помилка при збереженні',
                activateError: 'Помилка при активації',
                deleteError: 'Помилка при видаленні'
            },
            language: {
                title: 'Виберіть мову',
                description: 'Виберіть вашу бажану мову для користувацького інтерфейсу'
            },
        },
        chat: {
            ready: 'Готово',
            start: 'ПОЧАТИ',
            stop: 'ЗУПИНИТИ',
            initialMessage: 'Натисніть ПОЧАТИ для розмови в реальному часі.',
            listening: 'Слухаю...',
            speaking: 'Торстен говорить...',
            userLabel: 'Ти',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Напишіть повідомлення...',
            send: 'Надіслати',
            loginRequired: 'Будь ласка, увійдіть для використання цього сервісу.',
            loginButton: 'Вхід Зараз',
            magicLinkRequired: 'Будь ласка, використовуйте чарівне посилання для входу.',
            creditLimitError: 'Вашу щогодинну квоту вичерпано. Оновіть свій план (Medium/Premium) для продовження.',
            serviceDisabled: 'Служба чату наразі недоступна. Будь ласка, спробуйте пізніше.'
        },
        notifications: {
            error: 'Помилка',
            success: 'Успіх',
            info: 'Інформація',
            unknownError: 'Сталася невідома помилка'
        },
        cookie: {
            message: 'Цей вебсайт використовує файли cookie для надання вам найкращого можливого користувацького досвіду.',
            accept: 'Прийняти'
        },
        curriculum: {
                buttonLabel: 'Навчальна програма',
                buttonTitle: 'Показати зміст навчальної програми',
                modalTitle: 'Навчальна програма {app}',
                sections: {
                    topic: 'Тема навчальної програми',
                    explanation: 'Пояснення для дітей',
                    studentProfile: 'Профіль учня'
                },
                topic: {
                    empty: 'У бекенді не вказано тему навчальної програми для цього мікрододатку.',
                    missingDetail: 'Детальні дані навчальної програми для цього мікрододатку ще недоступні в бекенді.',
                    learningGoals: 'Навчальні цілі',
                    prerequisites: 'Передумови',
                    unitLabel: 'Розділ',
                    durationLabel: 'Тривалість',
                    difficultyLabel: 'Складність',
                    hours: 'год',
                    minutes: 'хв'
                },
                explanation: {
                    empty: 'Пояснення для дітей відсутнє.',
                    loadingPrepare: 'ШІ готує пояснення',
                    loadingExplain: 'ШІ пояснює тему дитячою мовою',
                    requestFailed: 'Не вдалося створити пояснення для дітей.'
                },
                studentProfile: {
                    country: 'Країна',
                    region: 'Область / Регіон',
                    schoolType: 'Тип школи',
                    grade: 'Клас',
                    noContext: 'Контекст учня відсутній.',
                    childProfileNotFound: 'Для поточного входу не знайдено профіль учня в бекенді.',
                    loginProfileIncomplete: 'Профіль входу ще не містить повного контексту учня.',
                    educationContextNotFound: 'Профіль учня знайдено, але не встановлено навчальну програму.',
                    noToken: 'Не знайдено учня, який увійшов у систему.'
                },
                errors: {
                    signInRequired: 'Увійдіть, щоб переглянути навчальну програму.',
                    appIdMissing: 'Відсутній ідентифікатор додатку.',
                    loadFailed: 'Не вдалося завантажити дані навчальної програми.'
                }
            }
    };
